import axios from "axios";

const deletetMediaInteractor = async (id: string | number) => {
  try {

    const response = await axios.delete(`${process.env.REACT_APP_API_URL}/media/${id}`);

    return response;
  } catch (error) {
    console.error(error);
  }
};

export default deletetMediaInteractor;
